var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import getModelDataFromComponents from './getModelDataFromComponents';
import { CONFIG_ELEMENT_IDS } from './constants';
import dataFetcher from './dataFetcher';
import initializeOneTrust from './initializeOneTrust';
export var DATA_LAYER_READY_EVENT = 'e_dataLayerReady';
export var getConfigElement = function (productLine) {
    var config = CONFIG_ELEMENT_IDS[productLine] ? document.querySelector(CONFIG_ELEMENT_IDS[productLine]) : null;
    if (!config)
        return null;
    return config;
};
export var getConfigLanguage = function (productLine) {
    var config = getConfigElement(productLine);
    if (!config)
        return;
    return (config).dataset.language;
};
export var getPageTypeFromRoute = function (route) { var _a, _b, _c, _d, _e; return (_e = (_d = (_c = (_b = (_a = route === null || route === void 0 ? void 0 : route.fields) === null || _a === void 0 ? void 0 : _a.gtmPageType) === null || _b === void 0 ? void 0 : _b.fields) === null || _c === void 0 ? void 0 : _c.value) === null || _d === void 0 ? void 0 : _d.value) !== null && _e !== void 0 ? _e : 'others'; };
export var getUserContextUrl = function (productLine) {
    var config = getConfigElement(productLine);
    if (!config)
        return null;
    var hostname = config.dataset.siteHostname;
    return hostname ? "https://".concat(hostname, "/context") : config.dataset.userContextUrl;
};
export var getApiUrl = function (productLine) {
    var _a;
    var config = getConfigElement(productLine);
    if (!config)
        return null;
    var hostname = (_a = config.dataset.apiHostname) !== null && _a !== void 0 ? _a : config.dataset.hostname;
    return hostname && "https://".concat(hostname);
};
export var pushGtmDataLayerReadyEvent = function (payload) {
    var dataLayer = typeof window !== 'undefined' && window.dataLayer ? window.dataLayer : [];
    // rm undefined values
    // eslint-disable-next-line no-param-reassign
    Object.keys(payload).forEach(function (key) { return !payload[key] && delete payload[key]; });
    dataLayer.push(payload);
    // Fire other gtm events in queue afterwards
    var gtmQueue = typeof window !== 'undefined' && window.gtmQueue ? window.gtmQueue : [];
    if (Array.isArray(gtmQueue) && gtmQueue.length) {
        dataLayer.push.apply(dataLayer, gtmQueue);
        // clean up queue
        window.gtmQueue = null;
    }
};
export var gtmDataLayerHandler = function (route, appName, mainPlaceholderName, errorHandler) { return __awaiter(void 0, void 0, void 0, function () {
    var productLine, pageType, language, payload, urlParamsStr, placeholderComponents, modelPagePayload, userContextUrl, apiUrl, accountUrl, buildsUrl, userContext, isLoggedIn, authToken, account, builds, err_1, errorMessage;
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                productLine = appName === null || appName === void 0 ? void 0 : appName.toLowerCase();
                pageType = getPageTypeFromRoute(route);
                language = getConfigLanguage(productLine);
                payload = {
                    pageType: pageType,
                    locale: language,
                    event: DATA_LAYER_READY_EVENT,
                    query_params: '',
                    userid: '',
                    loginStatus: 'not logged in',
                    numBuilds: undefined,
                };
                _c.label = 1;
            case 1:
                _c.trys.push([1, 6, , 7]);
                if (typeof window !== 'undefined') {
                    urlParamsStr = new URLSearchParams(window.location.search).toString();
                    if (urlParamsStr)
                        payload.query_params = "?".concat(decodeURIComponent(urlParamsStr));
                }
                placeholderComponents = (route === null || route === void 0 ? void 0 : route.placeholders) ? route === null || route === void 0 ? void 0 : route.placeholders[mainPlaceholderName] : null;
                modelPagePayload = getModelDataFromComponents(placeholderComponents, productLine);
                payload = __assign(__assign({}, payload), modelPagePayload);
                userContextUrl = getUserContextUrl(productLine);
                apiUrl = getApiUrl(productLine);
                if (!userContextUrl || !apiUrl) {
                    throw new Error("API urls required for a GTM dataLayer push of user data could not be constructed. \n        apiUrl: ".concat(apiUrl, "; userContextUrl: ").concat(userContextUrl, ";"));
                }
                accountUrl = "".concat(apiUrl, "/accounts/me");
                buildsUrl = "".concat(apiUrl, "/builds?AcceptLanguage=").concat(language);
                return [4 /*yield*/, dataFetcher(userContextUrl)];
            case 2:
                userContext = _c.sent();
                isLoggedIn = userContext === null || userContext === void 0 ? void 0 : userContext.data.IsUserLoggedIn;
                if (!isLoggedIn) return [3 /*break*/, 5];
                authToken = (_b = (_a = userContext === null || userContext === void 0 ? void 0 : userContext.data) === null || _a === void 0 ? void 0 : _a.AccessToken) === null || _b === void 0 ? void 0 : _b.access_token;
                return [4 /*yield*/, dataFetcher(accountUrl, null, authToken, false)];
            case 3:
                account = _c.sent();
                return [4 /*yield*/, dataFetcher(buildsUrl, null, authToken, false)];
            case 4:
                builds = _c.sent();
                payload = __assign(__assign({}, payload), { userid: account === null || account === void 0 ? void 0 : account.data.Id, loginStatus: 'logged in', numBuilds: builds === null || builds === void 0 ? void 0 : builds.data.length.toString() });
                _c.label = 5;
            case 5:
                // push payload
                pushGtmDataLayerReadyEvent(payload);
                return [3 /*break*/, 7];
            case 6:
                err_1 = _c.sent();
                errorMessage = "gtmPageLoad: ".concat(err_1);
                if (errorHandler) {
                    errorHandler(errorMessage);
                }
                else {
                    // eslint-disable-next-line no-console
                    console.warn(errorMessage);
                }
                // push payload even if there is an error
                pushGtmDataLayerReadyEvent(payload);
                return [3 /*break*/, 7];
            case 7:
                // initialize OneTrust
                initializeOneTrust();
                return [2 /*return*/];
        }
    });
}); };
export default gtmDataLayerHandler;
